import TNavbar from "./TNavbar";

export default TNavbar;
